import { $t } from '@/i18n';
/* eslint-disable no-param-reassign */
// 宽松水印模板
export const getLooseConfig = () => ({
    paddingX: 100,
    paddingY: 100,
    content: '{{ user.name }}',
    fontSize: 20,
    fillStyle: 'rgba(217, 217, 217, 0.5)',
    rotate: -30,
});
// 紧密水印模板
export const getCloseConfig = () => ({
    paddingX: 50,
    paddingY: 50,
    content: '{{ user.name }}',
    fontSize: 20,
    fillStyle: 'rgba(217, 217, 217, 0.5)',
    rotate: -30,
});
const defaultWatermarkId = 'wuji-watermark';
export const DEFAULT_WM_FONT_FAMILY = '-apple-system, BlinkMacSystemFont, "PingFang SC", "Microsoft YaHei"';
// 计算水印内容大小
const getWatermarkContentSize = ({ content, fontSize, fontFamily, rotate }) => {
    const canvas = document.createElement('canvas');
    canvas.style.position = 'absolute';
    const ctx = canvas.getContext('2d');
    document.body.appendChild(canvas);
    if (!ctx)
        return { contentWidth: 0, contentHeight: 0 };
    ctx.font = `${fontSize}px ${fontFamily || DEFAULT_WM_FONT_FAMILY}`;
    document.body.removeChild(canvas);
    const text = ctx.measureText(content);
    ctx.fillText(content, 50, 50);
    const textWidth = text.width;
    const textHeight = fontSize;
    const contentWidth = textWidth * Math.abs(Math.cos((rotate * Math.PI) / 180))
        + textHeight * Math.abs(Math.sin((rotate * Math.PI) / 180));
    const contentHeight = textHeight * Math.abs(Math.cos((rotate * Math.PI) / 180))
        + textWidth * Math.abs(Math.sin((rotate * Math.PI) / 180));
    return {
        contentWidth,
        contentHeight,
    };
};
// 移除指定水印
export const removeWatermark = (id = defaultWatermarkId) => {
    const el = document.getElementById(id);
    if (el)
        el.remove();
};
export const renderWatermark = ({ id = defaultWatermarkId, position = 'absolute', container = document.body, textBaseline = 'middle', paddingX = 0, paddingY = 0, top = 0, bottom = 0, left = 0, right = 0, fontFamily = DEFAULT_WM_FONT_FAMILY, fontSize = 28, fillStyle = 'rgba(230, 230, 230, .25)', content = $t('k_b7f6e22c'), rotate = 30, zIndex = 800, disableEvent = true, // 禁止事件
 } = {}) => {
    const canvas = document.createElement('canvas');
    const font = `${fontSize}px ${fontFamily || DEFAULT_WM_FONT_FAMILY}`;
    const { contentWidth, contentHeight } = getWatermarkContentSize({
        content,
        fontSize,
        fontFamily,
        paddingX,
        paddingY,
        rotate,
    });
    const width = contentWidth + paddingX * 2;
    const height = contentHeight + paddingY * 2;
    canvas.setAttribute('width', `${width}`);
    canvas.setAttribute('height', `${height}`);
    const ctx = canvas.getContext('2d');
    const rectCenterPoint = { x: width / 2, y: height / 2 };
    if (!ctx)
        return;
    ctx.textBaseline = textBaseline;
    ctx.font = font;
    ctx.fillStyle = fillStyle;
    ctx.translate(rectCenterPoint.x, rectCenterPoint.y);
    ctx.rotate((rotate * Math.PI) / 180);
    ctx.translate(-rectCenterPoint.x, -rectCenterPoint.y);
    ctx.fillText(content, paddingX, paddingY + contentHeight / 2);
    const base64Url = canvas.toDataURL();
    const el = document.getElementById(id);
    const watermarkDiv = el || document.createElement('div');
    // 使用 inset: 0 替代固定宽高，避免因 clientWidth/clientHeight 变化导致的滚动条闪烁
    const styleStr = `
    position: ${position};
    inset: ${top}px ${right}px ${bottom}px ${left}px;
    z-index: ${zIndex};
    ${disableEvent ? 'pointer-events: none;' : ''}
    background-repeat: repeat;
    background-image: url('${base64Url}')`;
    watermarkDiv.setAttribute('id', id);
    watermarkDiv.setAttribute('style', styleStr);
    if (!el && container) {
        container.style.position = 'relative';
        container.insertBefore(watermarkDiv, container.firstChild);
    }
};
